import { required, email, regex } from 'react-admin';

const validateRequired = [required('ra.validation.required')];
const validateRequiredEmail = [required('ra.validation.required'), email('поле повинно містити корркектний e-mail')];
const validateRequiredPhone = [required('ra.validation.required'), regex(/^\+380\d{9}$/, 'поле повинно містити номер телефону в форматі +380NNNNNNNNN')];
const validatePhone = [regex(/^\+380\d{9}$/, 'поле повинно містити номер телефону в форматі +380NNNNNNNNN')];
const validateRequiredEdrpou = [required('ra.validation.required'), regex(/^\d{10}$/, 'поле повинно містити код ІПН (10 цифр)')];
const validateRequiredHttps = [required('ra.validation.required'), regex(/^https:\/\//, 'поле повинно містити URL, що починається з https:// ')];
const validateRequiredTime = [required('ra.validation.required'), regex(/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/, 'поле повинно містити час в форматі nn:nn')];
const validateRequiredIban = [required('ra.validation.required'), regex(/^UA(\d{22}|\d{27})$/, 'поле повинно містити коректний IBAN (UAnnnnnnnnnnnnnnnnnnnnnn або UAnnnnnnnnnnnnnnnnnnnnnnnnnnn)')];
const validateRequiredTaxNumber = [required('ra.validation.required'), regex(/^\d{8}$|^\d{10}$/, 'поле повинно містити 8 або 10 цифр')];
const validateRequiredPassport = [required('ra.validation.required'), regex(/^([0-9]{9,10}|[А-ЯЁЇIЄҐ]{2}\d{6})$/, 'поле повинно містити номер паспорта (приклад АН123456) або номер біометричного паспорта ')];
const validateRequiredZip = [required('ra.validation.required'), regex(/^[0-9]{5}$/, 'поле повинно містити коректний поштовий індекс')];
const validateRequiredName = [required('ra.validation.required'), regex(/^(?!.*[ЫЪЭЁыъэё@%&$^#])[А-ЯҐЇІЄа-яґїіє’\\'\\ -]+$/, 'поле повинно містити тільки літери українського алфавіту або символи ’, \', - і пробіл')];
const validateRequiredDivisionName = [required('ra.validation.required'), regex(/^(?!.*[ЫЪЭЁыъэё@%&$^#])[a-zA-ZА-ЯҐЇІЄа-яґїіє0-9\\(\\)№" ,\\.-]+$/, 'поле повинно містити тільки літери українського і латинського алфавітів , цифри, символи №, ", (, ), -, крапка, кома і пробіл')];
const validateName = [regex(/^(?!.*[ЫЪЭЁыъэё@%&$^#])[А-ЯҐЇІЄа-яґїіє’\\'\\ -]+$/, 'поле повинно містити тільки літери українського алфавіту, символи ’, \', - і пробіл')];
const validateRequiredDate = [required('ra.validation.required'), regex(/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/, 'поле повинно містити дату в форматі ДД.ММ.ГГГГ')];
const validateRequiredExperience = [regex(/^\d+$/, 'поле повинно містити ціле число')];
const validateMD5 = [regex(/^[0-9a-fA-F]{32}$/, 'поле повинно містити тільки md5-хеш')];
const validateAttestationName = [regex(/^(?!.*[ЫЪЭЁыъэё@%&$^#])[a-zA-ZА-ЯҐЇІЄа-яґїіє0-9№\"!\^\*)\]\[(._-].*$/, "поле може зберігати лише літери української та латинського алфавітів, \". !, ^, *, [, ], (, ), ., _, -")];

const validateLegalEntityCreation = (values, flag) => {
    const regExpStreets = /^(?!.*[ЫЪЭЁыъэё@%&$^#])[А-ЯҐЇІЄа-яґїіє0-9’\\'\\ -]+$/;
    const messageForErrorStreets = ['поле повинно містити тільки літери українського алфавіту, цифри, символи №, ", (, ), - і пробіл'];
    const regExpUkrainian = /^(?!.*[ЫЪЭЁыъэё@%&$^#])[А-ЯҐЇІЄа-яґїіє’\\'\\ -]+$/;
    const messageForErrorUkrainian = ['поле повинно містити тільки літери українського алфавіту або символи ’, \', - і пробіл'];

    const errors = {};
    errors.license = {};

    if (!values.mobilePhoneNumber && !values.stationaryPhoneNumber) {
        errors.mobilePhoneNumber = ['Вкажіть мобільний або стаціонарний телефон'];
    }

    if (flag && !values.license?.id) {
        //errors.license = {};
        errors.license.id = ['ra.validation.required'];
    }

    if (!flag && !values.license?.issuedBy) {
        //errors.license = {};
        errors.license.issuedBy = ['ra.validation.required'];
    }

    if (!flag && !values.license?.activeFromDate) {
        //errors.license = {};
        errors.license.activeFromDate = ['ra.validation.required'];
    }

    if (!flag && !values.license?.issuedDate) {
        errors.license = {};
        errors.license.issuedDate = ['ra.validation.required'];
    }

    if (!flag && !values.license?.orderNo) {
        //errors.license = {};
        errors.license.orderNo = ['ra.validation.required'];
    }

    if (!(regExpStreets.test(values.residenceAddress?.street))) {
        errors.residenceAddress = {};
        errors.residenceAddress.street = messageForErrorStreets;
    }

    if (!values.publicOffer || !values.publicOffer.consent) {
        errors.publicOffer = {};
        errors.publicOffer.consent = ['Вам необхідно підтвердити публічну оферту'];
    }

    if (!(/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/.test(values.archive?.date)) && !!values.archive?.date) {
        errors.archive = {};
        errors.archive.date = ['поле повинно містити дату в форматі ДД.ММ.ГГГГ'];
    }

    if (!(regExpUkrainian.test(values.license?.whatLicensed)) && !!values.license?.whatLicensed) {
        //errors.license = {};
        errors.license.whatLicensed = messageForErrorUkrainian;
    }

    if (!(regExpUkrainian.test(values.beneficiary)) && !!values.beneficiary) {
        errors.beneficiary = messageForErrorUkrainian;
    }

    if (!flag && values.license) {
        //errors.license = {};
        // if (values.license.issuedDate && values.license.activeFromDate) {
        //     let licenseDate = new Date(values.license.issuedDate);
        //     let activeFromDate = new Date(values.license.activeFromDate);
        //
        //     if (activeFromDate.getTime() < licenseDate.getTime()) {
        //         // if (!errors.license) {
        //         //     errors.license = {};
        //         // }
        //
        //         errors.license.activeFromDate = ['Початок дії ліцензії не може бути раніше дати видачі ліцензії'];
        //     }
        // }

        if (values.license.activeFromDate && values.license.expiryDate) {
            let activeFromDate = new Date(values.license.activeFromDate);
            let expiryDate = new Date(values.license.expiryDate);

            if (activeFromDate.getTime() > expiryDate.getTime()) {
                // if (!errors.license) {
                //     errors.license = {};
                // }

                errors.license.expiryDate = ['Дата закінчення дії ліцензії не може бути раніше дати початку дії'];
            }
        }
    }

    if (!flag && !values.license?.activeFromDate) {
        //errors.license = {};
        errors.license.activeFromDate = ['ra.validation.required'];
    }

    if (!flag && !values.license?.issuedDate) {
       // errors.license = {};
        errors.license.issuedDate = ['ra.validation.required'];
    }

    checkSign(values, errors);

    return errors
};

const checkSign = (values, errors) => {
    if (
        values.tab === 0
        || typeof values.tab === 'undefined'
    ) {
        if (!values.sign) {
            errors.sign = ['Вкажіть файл ЕЦП'];
        }
        if (!values.password) {
            errors.password = ['Вкажіть пароль ЕЦП'];
        }
    } else if (values.tab === 2 && values.gryadaMethod === 'credentials') {
        if (!values.gryadaLogin) {
            errors.gryadaLogin = ['Вкажіть логін'];
        }
        if (!values.gryadaPassword) {
            errors.gryadaPassword = ['Вкажіть пароль'];
        }
    }

    if (values.tab === 1) {
        if (!values.ca) {
            errors.ca = ['Вкажіть КНЕДП'];
        }
        if (!values.signType) {
            errors.signType = ['Вкажіть тип ключа'];
        }
        if (!values.signPath) {
            errors.signPath = ['Вкажіть шлях до контейнера'];
        }
        if (!values.password2) {
            errors.password2 = ['Вкажіть пароль ЕЦП'];
        }
    }
}

const validateDivisionCreate = (values) => {
    const errors = {};
    const regExpBuilding = /^(?!.*[ЫЪЭЁыъэё@%&$^#])[А-ЯҐЇІЄа-яґїіє0-9’\\'\\\/ -]+$/;
    const regExpStreets = /^(?!.*[ЫЪЭЁыъэё@%&$^#])[А-ЯҐЇІЄа-яґїіє0-9’\\'\\ -]+$/;
    const messageForErrorStreets = ['поле повинно містити тільки літери українського алфавіту, цифри, символи №, ", (, ), - і пробіл'];
    const regExpWorkingHours = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
    const messageForErrorWorkingHours = ['поле повинно містити час в форматі nn:nn'];

    if (!(regExpStreets.test(values.street))) {
        errors.street = messageForErrorStreets;
    }

    if (!(regExpBuilding.test(values.building)) && !!values.building) {
        errors.building = messageForErrorStreets;
    }

    if (!(regExpBuilding.test(values.apartment)) && !!values.apartment) {
        errors.apartment = messageForErrorStreets;
    }

    if (values.workingHoursMon) {
        errors.workingHoursMon = [];
        values.workingHoursMon.forEach((item, i) => {
            if (
                typeof values.workingHoursMon === 'undefined'
                || typeof values.workingHoursMon[i] === 'undefined'
            ) {
                return {};
            }

            errors.workingHoursMon[i] = {};
            if (values.workingHoursMon[i].start && !(regExpWorkingHours.test(values.workingHoursMon[i].start))) {
                errors.workingHoursMon[i].start = messageForErrorWorkingHours;
            }
            if (values.workingHoursMon[i].end && !(regExpWorkingHours.test(values.workingHoursMon[i].end))) {
                errors.workingHoursMon[i].end = messageForErrorWorkingHours;
            }
        })
    }

    if (values.workingHoursTue) {
        errors.workingHoursTue = [];
        values.workingHoursTue.forEach((item, i) => {
            if (
                typeof values.workingHoursTue === 'undefined'
                || typeof values.workingHoursTue[i] === 'undefined'
            ) {
                return {};
            }

            errors.workingHoursTue[i] = {};
            if (values.workingHoursTue[i].start && !(regExpWorkingHours.test(values.workingHoursTue[i].start))) {
                errors.workingHoursTue[i].start = messageForErrorWorkingHours;
            }
            if (values.workingHoursTue[i].end && !(regExpWorkingHours.test(values.workingHoursTue[i].end))) {
                errors.workingHoursTue[i].end = messageForErrorWorkingHours;
            }
        })
    }

    if (values.workingHoursWed) {
        errors.workingHoursWed = [];
        values.workingHoursWed.forEach((item, i) => {
            if (
                typeof values.workingHoursWed === 'undefined'
                || typeof values.workingHoursWed[i] === 'undefined'
            ) {
                return {};
            }

            errors.workingHoursWed[i] = {};
            if (values.workingHoursWed[i].start && !(regExpWorkingHours.test(values.workingHoursWed[i].start))) {
                errors.workingHoursWed[i].start = messageForErrorWorkingHours;
            }
            if (values.workingHoursWed[i].end && !(regExpWorkingHours.test(values.workingHoursWed[i].end))) {
                errors.workingHoursWed[i].end = messageForErrorWorkingHours;
            }
        })
    }

    if (values.workingHoursThu) {
        errors.workingHoursThu = [];
        values.workingHoursThu.forEach((item, i) => {
            if (
                typeof values.workingHoursThu === 'undefined'
                || typeof values.workingHoursThu[i] === 'undefined'
            ) {
                return {};
            }

            errors.workingHoursThu[i] = {};
            if (values.workingHoursThu[i].start && !(regExpWorkingHours.test(values.workingHoursThu[i].start))) {
                errors.workingHoursThu[i].start = messageForErrorWorkingHours;
            }
            if (values.workingHoursThu[i].end && !(regExpWorkingHours.test(values.workingHoursThu[i].end))) {
                errors.workingHoursThu[i].end = messageForErrorWorkingHours;
            }
        })
    }

    if (values.workingHoursFri) {
        errors.workingHoursFri = [];
        values.workingHoursFri.forEach((item, i) => {
            if (
                typeof values.workingHoursFri === 'undefined'
                || typeof values.workingHoursFri[i] === 'undefined'
            ) {
                return {};
            }

            errors.workingHoursFri[i] = {};
            if (values.workingHoursFri[i].start && !(regExpWorkingHours.test(values.workingHoursFri[i].start))) {
                errors.workingHoursFri[i].start = messageForErrorWorkingHours;
            }
            if (values.workingHoursFri[i].end && !(regExpWorkingHours.test(values.workingHoursFri[i].end))) {
                errors.workingHoursFri[i].end = messageForErrorWorkingHours;
            }
        })
    }

    if (values.workingHoursSat) {
        errors.workingHoursSat = [];
        values.workingHoursSat.forEach((item, i) => {
            if (
                typeof values.workingHoursSat === 'undefined'
                || typeof values.workingHoursSat[i] === 'undefined'
            ) {
                return {};
            }

            errors.workingHoursSat[i] = {};
            if (values.workingHoursSat[i].start && !(regExpWorkingHours.test(values.workingHoursSat[i].start))) {
                errors.workingHoursSat[i].start = messageForErrorWorkingHours;
            }
            if (values.workingHoursSat[i].end && !(regExpWorkingHours.test(values.workingHoursSat[i].end))) {
                errors.workingHoursSat[i].end = messageForErrorWorkingHours;
            }
        })
    }

    if (values.workingHoursSun) {
        errors.workingHoursSun = [];
        values.workingHoursSun.forEach((item, i) => {
            if (
                typeof values.workingHoursSun === 'undefined'
                || typeof values.workingHoursSun[i] === 'undefined'
            ) {
                return {};
            }

            errors.workingHoursSun[i] = {};
            if (values.workingHoursSun[i].start && !(regExpWorkingHours.test(values.workingHoursSun[i].start))) {
                errors.workingHoursSun[i].start = messageForErrorWorkingHours;
            }
            if (values.workingHoursSun[i].end && !(regExpWorkingHours.test(values.workingHoursSun[i].end))) {
                errors.workingHoursSun[i].end = messageForErrorWorkingHours;
            }
        })
    }
    return errors;
}

const validateContractRequestCreation = (values) => {
    const errors = {};
    const MAX_PERIOD_DAYS = 1096;

    if (!values.consent) {
        errors.consent = ['Вам необхідно підтвердити публічну оферту'];
    }

    let current = new Date();
    current.setHours(23);
    current.setMinutes(59);
    current.setSeconds(59);

    if (values.endDate) {
        let end = new Date(values.endDate);

        if (end.getTime() < current.getTime()) {
            errors.endDate = ['Дата закінчення не може бути меншою або дорівнювати поточной'];
        }
    }

    if (values.startDate && values.endDate) {
        let start = new Date(values.startDate);
        let end = new Date(values.endDate);

        if (start.getTime() > end.getTime()) {
            errors.endDate = ['Дата закінчення не може бути менше дати початку'];
        } else if (start.getTime() === end.getTime()) {
            errors.endDate = ['Дата закінчення дії не повинна дорівнювати даті початку'];
        // } else if (end.getFullYear() - start.getFullYear() > 0) {
        //     errors.endDate = ['Договір має починатися та закінчуватися в одному році'];
        } else if ((end.getTime() - start.getTime()) / 86400 / 1000 > MAX_PERIOD_DAYS) {
            errors.endDate = ['Срок договору не може бути більше ' + MAX_PERIOD_DAYS + ' днів'];
        }
    }


    if (values.contractorBase === 'Запису в Єдиному державному реєстрі юридичних осіб, фізичних осіб-підприємців та громадсmких формувань') {
        if (typeof values.recordNumber === 'undefined' || values.recordNumber.trim() === '') {
            errors.recordNumber = ['Вкажіть номер запису у реєстрі'];
        }
        if (typeof values.recordDate === 'undefined' || !values.recordDate) {
            errors.recordDate = ['Вкажіть дату внесення номера запису до реєстру'];
        }
    }

    checkSign(values, errors);

    return errors;
}

const validateContractRequestUpdate = (values) => {
   const errors = {};

    if (!values.consent) {
        errors.consent = ['Вам необхідно підтвердити публічну оферту'];
    }

    if (values.endDate) {
        let end = new Date(values.endDate);
        let oldEnd = new Date(values.oldEndDate);

        if (oldEnd.getTime() > end.getTime()) {
            errors.endDate = ['Дата закінчення не може бути менше ніж попередня дата'];
        } else if (
            (
                end.getFullYear() === oldEnd.getFullYear()
                && end.getMonth() - oldEnd.getMonth() > 3
            )
            ||             (
                end.getFullYear() === oldEnd.getFullYear()
                && end.getMonth() - oldEnd.getMonth() === 3
                && end.getDate() > oldEnd.getDate()
            )
            || (
                end.getFullYear() > oldEnd.getFullYear()
                && (12 + end.getMonth()) - oldEnd.getMonth() > 3
            )
            || (
                end.getFullYear() > oldEnd.getFullYear()
                && (12 + end.getMonth()) - oldEnd.getMonth() === 3
                && end.getDate() > oldEnd.getDate()
            )
        ) {
            errors.endDate = ['Зазначена дата закінчення не може бути більше поточної більш ніж на 3 календарні місяці'];
        }
    }

    return errors;
}

const validateEmployeeCreation = (values) => {
    const errors = {};
    const specialityOfficioStatuses = [];
    errors.doctor = {};
    errors.doctor.specialities = [];

    if (!values.employeeType) {
        errors.employeeType = ['ra.validation.required'];
    }

    if (
        values.employeeType === 'PHARMACIST'
    ) {
        if (
            typeof values.doctor?.specialities === 'undefined'
            || values.doctor?.specialities.length === 0
        ) {
            errors.doctor.specialities = ['ra.validation.required'];
        }
        if (
            typeof values.doctor?.educations === 'undefined'
            || values.doctor?.educations.length === 0
        ) {
            errors.doctor.educations = ['ra.validation.required'];
        }
    }

    if (values.doctor?.specialities) {
        errors.doctor = {};
        errors.doctor.specialities = [];

        values.doctor.specialities.forEach((item, i) => {
            // if (
            //     typeof values.doctor.specialities === 'undefined'
            //     || typeof values.doctor.specialities[i] === 'undefined'
            // ) {
            //     return {};
            // }

            errors.doctor.specialities[i] = {};


            if (
                values.doctor.specialities[i]?.attestationName
                && !/^(?!.*[ЫЪЭЁыъэё@%&$^#])[a-zA-ZА-ЯҐЇІЄа-яґїіє0-9№\"!\^\*)\]\[(._-].*$/.test(values.doctor.specialities[i]?.attestationName)
            )
            {
                errors.doctor.specialities[i].attestationName = ['поле може зберігати лише літери української та латинського алфавітів, \". !, ^, *, [, ], (, ), ., _, -'];
            }

            if (values.doctor?.specialities[i]?.level !== 'NOT_APPLICABLE') {
                if (!values.doctor.specialities[i]?.qualificationType) {
                    errors.doctor.specialities[i].qualificationType = ['ra.validation.required'];
                }

                if (!values.doctor.specialities[i]?.attestationName) {
                    errors.doctor.specialities[i].attestationName = ['ra.validation.required'];
                }

                if (!values.doctor.specialities[i]?.attestationDate) {
                    errors.doctor.specialities[i].attestationDate = ['ra.validation.required'];
                }

                if (!values.doctor.specialities[i]?.validToDate) {
                    errors.doctor.specialities[i].validToDate = ['ra.validation.required'];
                }
            }

            if (!values.doctor.specialities[i]?.speciality) {
                errors.doctor.specialities[i] = {};
                errors.doctor.specialities[i].speciality = ['ra.validation.required'];
            }

            if (!values.doctor.specialities[i]?.level) {
                errors.doctor.specialities[i] = {};
                errors.doctor.specialities[i].level = ['ra.validation.required'];
            }

            specialityOfficioStatuses.push(values.doctor.specialities[i]?.speciality_officio);
        })
    }

    if (Boolean(specialityOfficioStatuses.length)) {
        if(specialityOfficioStatuses.filter(item => item).length > 1) {
            specialityOfficioStatuses.forEach((item,i) => errors.doctor.specialities.push({speciality_officio: ['можлива тільки одна офіційна спеціальність']}));
        }

        if(specialityOfficioStatuses.filter(item => item).length === 0) {
            specialityOfficioStatuses.forEach((item,i) => errors.doctor.specialities.push({speciality_officio: ['ra.validation.required']}));
        }
    }

    if (values.party?.documents) {
        errors.party = {};
        errors.party.documents = [];

        values.party.documents.forEach((item, i) => {
            if (
                typeof values.party.documents === 'undefined'
                || typeof values.party.documents[i] === 'undefined'
            ) {
                return {};
            }

            let current = new Date();
            let issued = new Date(values.party.documents[i].issuedAt);

            if (issued.getTime() > current.getTime()) {
                errors.party.documents[i] = {};
                errors.party.documents[i].issuedAt = ['Дата видачі не може бути більше за поточну дату'];
            }

            if (values.party.documents[i].type === 'NATIONAL_ID') {
                if (!errors.party.documents[i]) {
                    errors.party.documents[i] = {};
                }
                if (!/^\d{9}$/.test(values.party.documents[i].number)) {
                    errors.party.documents[i].number = ['номер біометричного паспорта має складатися із 9 цифр'];
                }
            }

            if (values.party.documents[i].type === 'PASSPORT') {
                if (!errors.party.documents[i]) {
                    errors.party.documents[i] = {};
                }
                if (!/^(?!.*[ЫЪЭЁыъэё@%&$^#])[А-ЯҐЇІЄа-яґїіє]{2}\s?\d{6}$/.test(values.party.documents[i].number)) {
                    errors.party.documents[i].number = ['номер паспорта має бути у форматі АА123456'];
                }
            }
        });
    }

    if (values.doctor?.qualifications) {
        values.doctor.qualifications.forEach((item, i) => {
            // if (
            //     typeof values.doctor.qualifications === 'undefined'
            //     || typeof values.doctor.qualifications[i] === 'undefined'
            // ) {
            //     return {};
            // }

                errors.doctor.qualifications = [];
                errors.doctor.qualifications[i] = {};

                if (!values.doctor.qualifications[i]?.institutionName) {
                    errors.doctor.qualifications[i].institutionName = ['ra.validation.required'];
                }

                if (!values.doctor.qualifications[i]?.speciality) {
                    errors.doctor.qualifications[i].speciality = ['ra.validation.required'];
                }

                if (!values.doctor.qualifications[i]?.issuedDate) {
                    errors.doctor.qualifications[i].issuedDate = ['ra.validation.required'];
                }

                if (!values.doctor.qualifications[i]?.certificateNumber) {
                    errors.doctor.qualifications[i].certificateNumber = ['ra.validation.required'];
                }

                if (!values.doctor.qualifications[i]?.validTo) {
                    errors.doctor.qualifications[i].validTo = ['ra.validation.required'];
                }
        })
    }

    if (values.doctor?.educations) {
        values.doctor.educations.forEach((item, i) => {
            errors.doctor.educations = [];
            errors.doctor.educations[i] = {};
            // if (
            //     typeof values.doctor.educations === 'undefined'
            //     || typeof values.doctor.educations[i] === 'undefined'
            // ) {
            //     return {};
            // }

            if (!values.doctor.educations[i]?.country) {
                errors.doctor.educations[i].country = ['ra.validation.required'];
            }

            if (!values.doctor.educations[i]?.city) {
                errors.doctor.educations[i].city = ['ra.validation.required'];
            }

            if (!values.doctor.educations[i]?.institutionName) {
                errors.doctor.educations[i].institutionName = ['ra.validation.required'];
            }

            if (!values.doctor.educations[i]?.issuedDate) {
                errors.doctor.educations[i].issuedDate = ['ra.validation.required'];
            }

            if (!values.doctor.educations[i]?.diplomaNumber) {
                errors.doctor.educations[i].diplomaNumber = ['ra.validation.required'];
            }

            if (!values.doctor.educations[i]?.degree) {
                errors.doctor.educations[i].degree = ['ra.validation.required'];
            }

            if (!values.doctor.educations[i]?.speciality) {
                errors.doctor.educations[i].speciality = ['ra.validation.required'];
            }
            });
    }

    checkSign(values, errors);

    return errors;
}

const validateContractEdit = values => {
    const errors = {};

    if (!values.consent) {
        errors.consent = ['Вам необхідно підтвердити публічну оферту'];
    }

    if (values.newEndDate && values.endDate) {
        let start = new Date(values.startDate);
        let end = new Date(values.endDate);
        let newEnd = new Date(values.newEndDate);

        // if (end.getTime() > newEnd.getTime()) {
        //     errors.newEndDate = ['Нова дата закінчення має бути більшою за поточну'];
        // } else if (newEnd.getFullYear() - start.getFullYear() > 1) {
        //    errors.newEndDate = ['Рік закінчення дії договору не може бути більшим за рік початку більш ніж на 1'];
        // } else
            if (
            (
                (
                    newEnd.getFullYear() - end.getFullYear() === 0
                    &&
                    (
                        newEnd.getMonth() - end.getMonth() > 3
                        || (
                            newEnd.getMonth() - end.getMonth() === 3
                            && newEnd.getDay() - end.getDay() > 0
                        )
                    )
                )
                ||
                (
                    newEnd.getFullYear() - end.getFullYear() > 0
                    &&
                    (
                        12 + newEnd.getMonth() - end.getMonth() > 3
                        || (
                            12 + newEnd.getMonth() - end.getMonth() === 3
                            && newEnd.getDay() - end.getDay() > 0
                        )
                    )
                )
            )
        ) {
            errors.newEndDate = ['Договір не може бути пролонгований більш ніж на 3 місяці'];
        }
    }

    checkSign(values, errors);

    return errors;
}

const validateProvisionCreate = (values) => {
    const errors = {};
    checkSign(values, errors);

    return errors;
};

const validateLicenseCreate = (values) => {
    const errors = {};

    let issuedDate = new Date(values.issuedDate);
    let activeFromDate = new Date(values.activeFromDate);
    let expiryDate = new Date(values.expiryDate);

    if (issuedDate.getTime() >= activeFromDate.getTime()) {
        errors.issuedDate= ['Дата видачі ліцензії має бути меншою від дати початку дії ліцензії'];
    }

    if (activeFromDate.getTime() >= expiryDate.getTime()) {
        errors.activeFromDate = ['Дата початку дії ліцензії має бути меншою від дати закінчення дії ліцензії'];
    }

    return errors;
}

//^(?!.*[ЫЪЭЁыъэё@%&$^#])[a-zA-ZА-ЯҐЇІЄа-яґїіє0-9№\\\"!\\^\\*)\\]\\[(._-].*$
export default {
    validateRequired,
    validateRequiredEmail,
    validatePhone,
    validateRequiredPhone,
    validateRequiredEdrpou,
    validateRequiredTaxNumber,
    validateRequiredPassport,
    validateRequiredHttps,
    validateRequiredTime,
    validateRequiredIban,
    validateRequiredName,
    validateRequiredZip,
    validateRequiredDivisionName,
    validateName,
    validateMD5,
    validateAttestationName,
    validateRequiredDate,
    validateRequiredExperience,
    validateLegalEntityCreation,
    validateContractRequestCreation,
    validateContractRequestUpdate,
    validateDivisionCreate,
    validateEmployeeCreation,
    validateContractEdit,
    validateProvisionCreate,
    validateLicenseCreate
};
